import { useCreateBlockNote } from "@blocknote/react";
import { BlockNoteView } from "@blocknote/mantine";
import "@blocknote/core/fonts/inter.css";
import "@blocknote/mantine/style.css";

import React from 'react';

const DocEditor: React.FC = () => {
  const editor = useCreateBlockNote();

  return <BlockNoteView editor={editor} theme='light'  />;
};

export default DocEditor;